'use client';

import InteractiveFigure, { LabelConfig } from './InteractiveFigure';
import HardwareSvg from '../assets/HardwareFig';

const LABELS: LabelConfig[] = [
  // start at bottom of image an move
  { id: 'a1', label: 'Soil water potential sensor', description: 'Buried at 45 cm, it shows moisture and temperature in the lower root zone.' },
  { id: 'a2', label: 'Soil water potential sensor', description: 'Buried at 30 cm, it shows moisture and temperature in the main root zone, which responds more slowly to changes in moisture.' },
  { id: 'a3', label: 'Soil water potential sensor', description: 'Buried at 15 cm, it shows moisture and temperature in the topsoil and responds quickly after rain or irrigation.' },
  { id: 'a4', label: 'EC & soil moisture sensor', description: 'Measures electrical conductivity (EC), soil moisture, and temperature in the root zone. Used for planning fertigation.' },
  { id: 'a5', label: 'Dripline pressure sensor', description: 'Confirms that the dripline is pressurized and can alert you to dripline breaks or solenoid issues.' },
  { id: 'a6', label: 'Node', description: 'Powers the sensors and sends data to the cloud.' },
  { id: 'a7', label: 'Weather station', description: 'Measures local wind, temperature, and precipitation to inform irrigation decisions.' },
];

export default function HardwareFigure() {
  return (
    <InteractiveFigure
      FigureComponent={HardwareSvg}
      labels={LABELS}
      minWidth={800}
      centerOffset={-100}
    />
  );
}
